import Container from './container';
import H1 from './h1/H1';
import H2 from './h2/H2';

export { Container, H1, H2 };



// WEBPACK FOOTER //
// ./src/components/index.js